import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Modal } from "antd";

import ResultList from "../../app/generic/resultList";

const ImportResult = ({ entity, visible, onClose, whatFourth, resultData }) => {
  const intl = useIntl();
  const renderTitle = useCallback(
    (item) =>
      item.templateName
        ? intl.formatMessage(
            {
              id: "import.templateResult",
              defaultMessage: "Název šablony: {templateName} (šablona č.{row})",
            },
            { templateName: item.templateName, row: item.row }
          )
        : item.customerReference
        ? intl.formatMessage(
            {
              id: "import.referenceResult",
              defaultMessage:
                "Reference zásilky: {customerReference} (řádek {row})",
            },
            { customerReference: item.customerReference, row: item.row }
          )
        : item.name
        ? intl.formatMessage(
            {
              id: "import.customerResult",
              defaultMessage: "Zákazník {name} (řádek {row})",
            },
            { name: item.name, row: item.row }
          )
        : intl.formatMessage(
            {
              id: "import.entityResult",
              defaultMessage: "{entity} na řádku {row}",
            },
            {
              entity:
                entity === "consignment"
                  ? intl.formatMessage({
                      id: "consignment",
                      defaultMessage: "Zásilka",
                    })
                  : entity === "template"
                  ? intl.formatMessage({
                      id: "consignment.template.name",
                      defaultMessage: "Šablona",
                    })
                  : intl.formatMessage({
                      id: "customer",
                      defaultMessage: "Zákazník",
                    }),
              row: item.row,
            }
          ),
    [intl, entity]
  );
  const renderDescription = useCallback(
    (item) =>
      item.success
        ? intl.formatMessage({
            id: "import.success",
            defaultMessage: "Import dopadl úspěšně.",
          })
        : intl.formatMessage({
            id: "messages.processingError",
            defaultMessage: "Při zpracování nastala chyba!",
          }),
    [intl]
  );
  const renderStatusMessage = useCallback(
    (item) =>
      item.success
        ? intl.formatMessage({
            id: "messages.successSave",
            defaultMessage: "Úspěšně uloženo!",
          })
        : intl.formatMessage(
            {
              id: "import.error",
              defaultMessage: "Při importování {what} nastal problém!",
            },
            { what: whatFourth }
          ),
    [intl, whatFourth]
  );

  return (
    <Modal
      width={800}
      onOk={onClose}
      okText={intl.formatMessage({
        id: "messages.close",
        defaultMessage: "Zavřít",
      })}
      visible={visible}
      onCancel={onClose}
      title={intl.formatMessage({
        id: "import.result",
        defaultMessage: "Výsledek importu",
      })}
      cancelButtonProps={{ className: "display-none" }}
    >
      <ResultList
        titleMethod={renderTitle}
        descriptionMethod={renderDescription}
        stateMessageMethod={renderStatusMessage}
        results={resultData && resultData.importResults}
      />
    </Modal>
  );
};

export default ImportResult;
